"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighchartsOptionsProvider = exports.useHighchartsOptionsContext = exports.HighchartsOptionsContext = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const use_custom_compare_1 = require("use-custom-compare");
const lodash_1 = __importDefault(require("lodash"));
const DataProviderCommonTypes_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/DataProviderCommonTypes");
const initialState = {
    error: (0, DataProviderCommonTypes_1.getInitialDataProviderStateError)(),
    options: {},
    chartStatus: undefined
};
exports.HighchartsOptionsContext = React.createContext(undefined);
const useHighchartsOptionsContext = () => {
    const context = React.useContext(exports.HighchartsOptionsContext);
    if (!context) {
        throw new Error("useHighchartsOptionsContext must be used within a HighchartsOptionsContext.Provider");
    }
    return context;
};
exports.useHighchartsOptionsContext = useHighchartsOptionsContext;
function HighchartsOptionsProvider(props) {
    const [state, setState] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), lodash_1.default.cloneDeep(initialState));
    (0, use_custom_compare_1.useCustomCompareEffect)(() => {
        var _a;
        const chartStatus = props.chartStatus;
        // console.log("HighchartsOptionsProvider.useCustomCompareEffect: chartStatus", _.cloneDeep(chartStatus));
        try {
            if ((_a = props.error) === null || _a === void 0 ? void 0 : _a.isError) {
                setState({
                    error: {
                        isError: props.error.isError,
                        error: props.error.error,
                    },
                    options: {},
                    chartStatus: undefined
                });
            }
            else {
                const data = lodash_1.default.isNil(props.stateDataTransformFn) ? props.data : props.stateDataTransformFn(props.data);
                const result = props.highchartsOptionsProviderFn(data, props.parameters, chartStatus);
                // console.log("HighchartsOptionsProvider.useCustomCompareEffect: result.chartStatus", _.cloneDeep(result.chartStatus));
                if (result.options.exporting) {
                    result.options.exporting.enabled = false;
                }
                setState({
                    error: (0, DataProviderCommonTypes_1.getInitialDataProviderStateError)(),
                    options: result.options,
                    chartStatus: result.chartStatus
                });
            }
        }
        catch (e) {
            console.error("HighchartsOptionsProvider calculation failed:", e);
            setState({
                error: {
                    isError: true,
                    error: new Error("temporarilyUnavailable"),
                },
                options: {},
                chartStatus: undefined
            });
        }
    }, [props], lodash_1.default.isEqual);
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        state,
    }), [
        state,
    ], lodash_1.default.isEqual);
    return React.createElement(exports.HighchartsOptionsContext.Provider, { value: value }, props.children);
}
exports.HighchartsOptionsProvider = HighchartsOptionsProvider;
